export default {
  // Hero
  servicesHeroTag: "Ce Que Nous Offrons",
  servicesHeroTitle1: "Services Complets",
  servicesHeroTitle2: "pour l'Afrique de l'Est",
  servicesHeroDesc: "De l'enregistrement de l'entreprise à la participation aux appels d'offres, AIP fournit une suite complète de services pour accompagner votre parcours commercial en Afrique de l'Est.",
  pillRegistration: "Enregistrement d'Entreprise",
  pillCompliance: "Conformité Réglementaire",
  pillInvestment: "Facilitation de l'Investissement",
  pillExpansion: "Expansion Commerciale",
  pillTender: "Support d'Appels d'Offres",

  // Service 1 - Registration
  regServiceNum: "Service 01",
  regTitle: "Enregistrement d'Entreprise",
  regSubtitle: "Entrée sur le Marché",
  regDesc: "Nous gérons l'incorporation complète pour les entreprises étrangères au Rwanda et en Afrique de l'Est. Nos experts naviguent dans les réglementations locales, les organismes gouvernementaux et les exigences documentaires pour que vous puissiez vous concentrer sur le développement de votre entreprise.",
  regStep1Title: "Consultation Initiale",
  regStep1Desc: "Nous évaluons votre structure commerciale, votre secteur et les exigences du pays cible.",
  regStep2Title: "Préparation des Documents",
  regStep2Desc: "Notre équipe collecte, traduit et notarise tous les documents d'incorporation requis.",
  regStep3Title: "Dépôt Gouvernemental",
  regStep3Desc: "Nous déposons votre enregistrement auprès du Rwanda Development Board (RDB) ou de l'autorité compétente.",
  regStep4Title: "Fiscalité & Licences",
  regStep4Desc: "Obtenez votre NIF, licences commerciales et permis spécifiques au secteur.",
  regStep5Title: "Ouverture de Compte Bancaire",
  regStep5Desc: "Nous vous assistons pour l'ouverture d'un compte bancaire commercial local.",
  regStep6Title: "Lancement Opérationnel",
  regStep6Desc: "L'entreprise est entièrement enregistrée et prête à opérer légalement dans le pays.",
  regCta: "Commencer l'Enregistrement",
  regFormTitle: "Commencez l'Enregistrement de Votre Entreprise",
  regFormName: "Nom complet",
  regFormEmail: "Email",
  regFormCountry: "Pays d'Intérêt",
  regFormSector: "Secteur",
  regFormActivity: "Activité Commerciale",
  regFormSubmit: "Soumettre l'Intérêt d'Enregistrement",
  regRwandaTitle: "Pourquoi le Rwanda?",
  regRwandaDesc: "Le Rwanda se classe #2 en Afrique pour la facilité de faire des affaires. Propriété étrangère à 100%, aucune exigence de capital minimum et un enregistrement numérique en font le meilleur point d'entrée pour l'Afrique de l'Est.",
  regRwandaStat1: "Enregistrement Moyen",
  regRwandaStat2: "Capital Minimum",
  regRwandaStat3: "Propriété Étrangère",

  // Service 2 - Compliance
  complianceServiceNum: "Service 02 — Différenciateur Clé",
  complianceTitle: "Conformité Réglementaire",
  complianceSubtitle: "Licences",
  complianceDesc: "Notre équipe réglementaire possède une connaissance approfondie sectorielle pour enregistrer, licencier et rendre vos produits conformes — rapidement.",
  complianceItem1: "Médicaments & Dispositifs Médicaux",
  complianceItem1Desc: "Permis d'importation, licences de distribution, enregistrement de pharmacovigilance",
  complianceItem2: "Cosmétiques & Soins Personnels",
  complianceItem2Desc: "Notification de produits, évaluation de sécurité, conformité d'étiquetage",
  complianceItem3: "Agroalimentaire",
  complianceItem3Desc: "Certification FSMS, permis de sécurité alimentaire, certifications d'exportation",
  complianceItem4: "Compléments Alimentaires",
  complianceItem4Desc: "Enregistrement de nutraceutiques, approbation de allégations de santé, dédouanement",
  complianceItem5: "Produits Ménagers",
  complianceItem5Desc: "Enregistrement chimique, fiches de données de sécurité, licences d'importation",
  complianceItem6: "Permis d'Export & Import",
  complianceItem6Desc: "Facilitation du commerce, classification douanière, support documentaire",
  complianceCta: "Demander un Support de Conformité",

  // Service 3 - Investment
  investServiceNum: "Service 03 & 04",
  investTitle: "Facilitation de l'Investissement",
  investSubtitle: "Expansion Commerciale",
  investDesc: "Que vous soyez un investisseur international ou une entreprise africaine cherchant à s'étendre, AIP fournit les renseignements, les connexions et le support opérationnel dont vous avez besoin pour réussir.",
  investService1Title: "Support IDE",
  investService1Desc: "Support complet pour l'investissement direct étranger — des études de faisabilité à la mise en place opérationnelle.",
  investService2Title: "Matching Investisseur-Entreprise",
  investService2Desc: "Nous connectons les investisseurs internationaux avec des entreprises locales et des opportunités pré-vérifiées.",
  investService3Title: "Études de Marché",
  investService3Desc: "Analyse approfondie du marché, cartographie des concurrents et stratégie d'entrée pour les marchés d'Afrique de l'Est.",
  investService4Title: "Expansion Intra-Africaine",
  investService4Desc: "Support pour les entreprises africaines qui s'étendent sur le continent — réglementaire, juridique et opérationnel.",
  investCardTitle: "Connecter le Capital Mondial",
  investCardDesc: "avec les marchés à la plus forte croissance d'Afrique de l'Est",
  investCta: "Demander le Service",

  // Service 5 - Tender
  tenderServiceNum: "Service 05 — Expertise de Niche",
  tenderTitle: "Support",
  tenderSubtitle: "d'Appels d'Offres",
  tenderDesc: "Support complet de participation aux appels d'offres — de l'enregistrement à l'attribution. Nous gérons la complexité pour que vous puissiez vous concentrer sur la victoire.",
  tenderService1Title: "Enregistrement des Soumissionnaires",
  tenderService1Desc: "Enregistrez votre entreprise sur les portails d'appels d'offres nationaux et régionaux en Afrique de l'Est.",
  tenderService2Title: "Acquisition de Documents d'Appel d'Offres",
  tenderService2Desc: "Nous obtenons et analysons les documents d'appels d'offres en votre nom, garantissant que vous ne manquez aucune opportunité.",
  tenderService3Title: "Garanties & Cautions",
  tenderService3Desc: "Sourcing et gestion des cautions de soumission et garanties de performance auprès d'institutions financières de confiance.",
  tenderService4Title: "Préparation des Offres",
  tenderService4Desc: "Rédaction professionnelle des offres, soumissions techniques et stratégie de tarification pour maximiser les chances de succès.",
  tenderService5Title: "Représentation",
  tenderService5Desc: "AIP représente votre entreprise aux ouvertures des offres, réunions de clarification et négociations.",
  tenderService6Title: "Suivi & Monitoring",
  tenderService6Desc: "Suivi post-soumission, traçage de l'attribution des contrats et dépôt de réclamations si nécessaire.",
  tenderCta1: "Demander un Support d'Appels d'Offres",
  tenderCta2: "Voir les Appels d'Offres Actifs",
  tenderFormTitle: "Soumettre une Demande de Support d'Appels d'Offres",
  tenderFormCompany: "Nom de l'Entreprise",
  tenderFormEmail: "Email",
  tenderFormRef: "Référence de l'Appel d'Offres",
  tenderFormSector: "Secteur",
  tenderFormDetails: "Détails Complémentaires",
  tenderFormSubmit: "Soumettre la Demande",
  tenderFormCancel: "Annuler",
  tenderFormSuccessTitle: "Demande Reçue!",
  tenderFormSuccessBody: "Nos spécialistes des appels d'offres vous contacteront dans les 24 heures.",
};